import { createFileRoute, notFound } from '@tanstack/react-router';

import { DocsNotFoundPage, findGuide, GuidePage } from '@/features/docs';

export const Route = createFileRoute('/_authed/docs/guides/$slug')({
  loader: ({ params }) => {
    const guide = findGuide(params.slug);
    if (!guide) throw notFound();
    return guide;
  },
  component: function GuideRoute() {
    return <GuidePage guide={Route.useLoaderData()} />;
  },
  notFoundComponent: DocsNotFoundPage,
});
